export const competitorCircuitMainPosIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
  <path d="m12 2.35 3.02 6.12 6.76.98-4.89 4.77 1.15 6.73L12 17.77l-6.04 3.18 1.15-6.73-4.89-4.77 6.76-.98L12 2.35Z" fill="#111827"/>
</svg>`;

export const competitorCircuitCompetitorIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
  <path d="M6.2 5h3.3l1.1 5h2.8l1.1-5h3.3L22 15.8a4.2 4.2 0 1 1-8.2 1.7h-3.6A4.2 4.2 0 1 1 2 15.8L6.2 5Zm.3 9.2a2.3 2.3 0 1 0 0 4.6 2.3 2.3 0 0 0 0-4.6Zm11 0a2.3 2.3 0 1 0 0 4.6 2.3 2.3 0 0 0 0-4.6ZM11 12l-.55 2.5h3.1L13 12h-2Z" fill="#111827"/>
</svg>`;
